// extracted by mini-css-extract-plugin
module.exports = {"error":"otp-channel-selector_error__XY2C7"};